import React, { ReactNode } from "react";

//#region 型定義

interface CardProps {
  /** カードのタイトル */

  title?: string;

  /** カードの説明文 */

  description?: string;

  /** カードの内容 */

  children: ReactNode;

  /** 追加のスタイリング */

  className?: string;

  /** カードのヘッダーに表示する追加のアクション */

  headerActions?: ReactNode;

  /** カードのフッターに表示する内容 */

  footer?: ReactNode;

  /** 影の大きさ */

  shadow?: "sm" | "md" | "lg" | "none";
}

//#endregion

/**

 * カードコンポーネント

 * @description 情報を表示するためのカードを提供するコンポーネント

 */

const Card: React.FC<CardProps> = ({ children, ...props }) => {
  // 影のスタイル

  const shadowStyles = {
    none: "",

    sm: "shadow-sm",

    md: "shadow",

    lg: "shadow-lg",
  };

  return (
    <div
      className={`

            bg-white 

            rounded-lg 

            ${shadowStyles[props.shadow || "md"]}

            overflow-hidden

            ${props.className}

        `}
    >
      {/* ヘッダー部分 */}

      {(props.title || props.description || props.headerActions) && (
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-start">
            <div>
              {props.title && (
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                  {props.title}
                </h3>
              )}

              {props.description && (
                <p className="mt-1 text-sm text-gray-500">
                  {props.description}
                </p>
              )}
            </div>

            {props.headerActions && (
              <div className="ml-4">{props.headerActions}</div>
            )}
          </div>
        </div>
      )}

      {/* メインコンテンツ */}

      <div className="p-6">{children}</div>

      {/* フッター */}

      {props.footer && (
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
          {props.footer}
        </div>
      )}
    </div>
  );
};

export default Card;
